import Router from 'vue-router'
import Vue from 'vue'
import homePage from '../views/homePage.vue'
import aboutPage from '../views/aboutPage.vue'
import cloudPage from '../views/cloudPage.vue'
import calculatePage from '../views/calculatePage.vue'
import ecologyPage from '../views/ecologyPage.vue'
import preferentialPage from '../views/preferentialPage.vue'
import registerPage from '../views/registerPage.vue'

Vue.use(Router)

// 防止跳转同一路径出异常
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
// { name: '首页', url: '/' },
// { name: '苏智云', url: '/cloud' },
// { name: '算力市场', url: '/calculate' },
// { name: '生态市场', url: '/ecology' },
// { name: '优惠政策', url: '/preferential' },
// { name: '关于我们', url: '/about' },
const router = new Router({
  mode: 'hash', // 可以使用HTML5历史记录，去掉URL中的#
  routes: [
    {
      path: '/',
      name: 'home',
      component: homePage
    },
    {
      path: '/cloud',
      name: 'cloud',
      component: cloudPage
    },
    {
      path: '/ecology',
      name: 'ecology',
      component: ecologyPage
    }, {
      path: '/calculate',
      name: 'calculate',
      component: calculatePage
    }, {
      path: '/preferential',
      name: 'preferential',
      component: preferentialPage
    }, {
      path: '/about',
      name: 'about',
      component: aboutPage
    }, {
      path: '/register',
      name: 'register',
      component: registerPage
    }
  ]
})

export default router

